<template>
  <section class=""
           style="padding-top: 1.5rem">

    <b-loading :active.sync="isLoading"
               :canCancel="false"></b-loading>

    <div class="container">

      <div class="columns">
        <div class="column"></div>
        <div class="column is-three-quarters">

          <div class="box has-text-centered"
               v-if="currentState === tweetStates.default">
            <div v-if="!isLoggedIn">

              <section class="hero">
                <div class="hero-body">
                  <div class="container">
                    <h1 class="title">
                      Nearly done!
                    </h1>
                    <h2 class="subtitle">
                      Let's get you signed in.
                    </h2>
                    <h6 class="subtitle is-6">
                      Please click the button below and authorize TweetMySlides to send tweets on your behalf.
                    </h6>
                  </div>
                </div>
              </section>

              <a @click.prevent="authenticate()">
                <img src="../../assets/sign-in-with-twitter-gray.png"
                     width="158"
                     height="28" />
              </a>
            </div>
            <div v-else>
              <section class="hero">
                <div class="hero-body">
                  <div class="container">
                    <h1 class="title">
                      Hello {{ twitterProfile.name }}!
                    </h1>
                    <h2 class="subtitle">
                      @{{ twitterProfile.screen_name }}
                    </h2>
                    <h6 class="subtitle is-6">You're ready to go.</h6>
                  </div>
                </div>
              </section>

              <!-- Main container -->
              <nav class="level">
                <!-- Left side -->
                <div class="level-left">
                  <div class="level-item">
                    <a class="button is-warning"
                       @click.prevent="logOut()">Log out</a>
                  </div>
                </div>

                <!-- Right side -->
                <div class="level-right">
                  <div class="level-item">
                    <a class="button is-link"
                       @click.prevent="submit()">Tweet sequence!</a>
                  </div>
                </div>
              </nav>

            </div>
          </div>

          <div class="has-text-centered"
               v-if="currentState === tweetStates.processing">
            <div class="box">
              Processing, please wait...
              <spinner style="display: inline-block; margin-left: 0.7rem; margin-bottom: -0.9rem;"
                       :size="38"></spinner>
            </div>
          </div>

          <div class="has-text-centered"
               v-if="currentState === tweetStates.success">
            <div class="box">
              <section class="hero">
                <div class="hero-body">
                  <div class="container">
                    <h1 class="title">
                      Success!
                    </h1>
                    <h2 class="subtitle">
                      You can see your tweet sequence below.
                    </h2>
                    <a class="button is-info"
                       @click.prevent="goToUploadStep()">Upload another presentation</a>
                    <br>
                    <br>
                    <h6 class="subtitle is-6">P.S. We'd love your
                      <a @click.prevent="showFeedbackModal()">feedback</a> on how we can make TweetMySlides more useful. :)</h6>
                  </div>
                </div>
              </section>
            </div>

            <div v-for="tweet in successResult"
                 :key="tweet.id">
              <Tweet :id="tweet.idStr"
                     :options="{ conversation: 'none', width: '520', align: 'center' }"></Tweet>
            </div>
          </div>

        </div>
        <div class="column"></div>
      </div>

    </div>
  </section>
</template>

<script>
import TweetSectionBase from './TweetSectionBase.vue';

export default {
  name: 'TweetSection',

  extends: TweetSectionBase,

  components: {

  },

  props: {

  },

  data: function () {
    return {

    };
  },

  mounted () {

  },

  computed: {

  },

  methods: {

  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/create/TweetSection.vue